<template>
  <div class="booking-menu">
    <v-flex pa-2>
      <p v-html="tooltipForTaxi(taxi)"></p>
    </v-flex>
    <ul style="cursor: pointer; padding-left: 0px !important;">
      <li class="padding-li" key="message" @click="message">
        <p style="padding-right: 12px;">Message Driver</p>
      </li>
      <li class="padding-li">
        <a :href="'tel:' + formatNumber(taxi.driver.contact_number)">
          <p>Call Driver {{formatNumber(taxi.driver.contact_number)}}</p>
        </a>
      </li>
    </ul>
    <v-dialog v-model="messageDialog" width="600px">
      <MessageDriverDialog @sent="messageDialog = false" :taxi="taxi" />
    </v-dialog>
  </div>
</template>

<script>
import { replaceStart } from "@/components/util/PhoneNumbers.js";

import { Overwatch } from "@/components/util/Overwatch.js";

import MessageDriverDialog from "@/components/widget/menu/MessageDriverDialog.vue";

export default {
  components: {
    MessageDriverDialog
  },
  name: "DriverMenu",
  props: {
    taxi: Object
  },
  data() {
    return {
      mode: null,
      loading: false,
      messageDialog: false
    };
  },
  mounted: function() {
    // console.log(this.booking);
  },
  methods: {
    message: function() {
      if (this.taxi.driver.chat_enabled == true) {
        this.$store.state.driverToMessage = this.taxi.driver.id;
        this.$store.state.driverToMessageName = this.taxi.driver.name;
        console.log(this.taxi.driver.id);
      } else {
        this.messageDialog = true;
      }
    },
    formatNumber: function(number) {
      return replaceStart(number);
    },
    tooltipForTaxi: function(taxi) {
      var ow = new Overwatch(this.taxis, this.bookings);

      return ow.tooltipForTaxi(taxi);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.booking-menu {
  background-color: white;
}

.confirm-container {
  padding: 12px;
}

.padding-li {
  padding-right: 12px;
}
</style>
